import {
  IApiEventList,
  IApiFormSessionToken,
  IApiFormSessionTokenField,
} from './accreditation-forms-interfaces';
import ENDPOINTS, { ENDPOINTS_SEGMENTS } from '../../constants/endpoints';
import Api from '../../api';

export const getFormSession = (
  tenantId: string,
  formSessionToken: string,
): Promise<IApiFormSessionTokenField> => {
  const url = `${ENDPOINTS.GET_FORM_SESSION.replace(
    ENDPOINTS_SEGMENTS.TENANT_ID,
    tenantId,
  ).replace(ENDPOINTS_SEGMENTS.FORM_SESSION_TOKEN, formSessionToken)}`;
  const response: Promise<IApiFormSessionTokenField> = Api.get(url);
  return response;
};

export const createFormSessionFromOrganisationTokenSession = (
  tenantId: string,
  organisationFormSessionToken: string,
): Promise<IApiFormSessionTokenField> => {
  const url = `${ENDPOINTS.CREATE_FORM_SESSION_FROM_ORGANISATION.replace(
    ENDPOINTS_SEGMENTS.TENANT_ID,
    tenantId,
  ).replace(
    ENDPOINTS_SEGMENTS.FORM_ORGANISATION_SESSION_TOKEN,
    organisationFormSessionToken,
  )}`;

  const response: Promise<IApiFormSessionTokenField> = Api.post(url, {});
  return response;
};

export const getCountryStates = (): Promise<string[]> => {
  const url = `${ENDPOINTS.GET_COUNTRY_STATES}`;
  const response: Promise<string[]> = Api.get(url, {});
  return response;
};

export const createFormSessionFromGenericRegistration = (
  tenantId: string,
  projectId: string,
  formDefId: string,
  eventId?: string,
): Promise<IApiFormSessionToken> => {
  const url = `${ENDPOINTS.CREATE_FORM_SESSION_FROM_GENERIC_REGISTRATION.replace(
    ENDPOINTS_SEGMENTS.TENANT_ID,
    tenantId,
  )}`;
  // .replace(ENDPOINTS_SEGMENTS.FORM_PROJECT_ID, projectId)
  // .replace(ENDPOINTS_SEGMENTS.FORM_DEF_ID, formDefId)}`;

  const response: Promise<IApiFormSessionToken> = Api.post(url, {
    projectId,
    formDefId,
    eventId,
  });
  return response;
};

export const getApiEventsList = (
  tenantId: string,
  formSessionToken: string,
): Promise<IApiEventList> => {
  const url = `${ENDPOINTS.GET_EVENTS.replace(
    ENDPOINTS_SEGMENTS.TENANT_ID,
    tenantId,
  ).replace(ENDPOINTS_SEGMENTS.FORM_SESSION_TOKEN, formSessionToken)}`;
  const response: Promise<IApiEventList> = Api.get(url);
  return response;
};

export const getDynamicApiData = (
  apiEndpoint: string,
  method: string,
  postParams: any,
): Promise<any> => {
  // const url = `${apiEndpoint.replace(ENDPOINTS_SEGMENTS.TENANT_ID, tenantId).replace(
  //   ENDPOINTS_SEGMENTS.FORM_SESSION_TOKEN,
  //   formSessionToken,
  // )}`;

  if (method === 'GET') {
    const response: Promise<any> = Api.get(apiEndpoint);
    return response;
  } else if (method === 'POST') {
    const response: Promise<any> = Api.post(apiEndpoint, postParams);
    return response;
  }
};

export const getGermanStatesList = (
  tenantId: string,
  formSessionToken: string,
): Promise<string[]> => {
  const url = `${ENDPOINTS.GET_GERMAN_STATES.replace(
    ENDPOINTS_SEGMENTS.TENANT_ID,
    tenantId,
  ).replace(ENDPOINTS_SEGMENTS.FORM_SESSION_TOKEN, formSessionToken)}`;
  const response: Promise<string[]> = Api.get(url);
  return response;
};

export const getApiAttractionSlots = (
  tenantId: string,
  formSessionToken: string,
): Promise<IApiEventList> => {
  const url = `${ENDPOINTS.GET_ATTRACTION_SLOTS.replace(
    ENDPOINTS_SEGMENTS.TENANT_ID,
    tenantId,
  ).replace(ENDPOINTS_SEGMENTS.FORM_SESSION_TOKEN, formSessionToken)}`;
  const response: Promise<IApiEventList> = Api.get(url);
  return response;
};

/**
 * Get list of countries for those states are allowed
 * @param tenantId
 * @param formSessionToken
 * @returns
 */
export const getCountriesWithAllowedStates = (
  tenantId: string,
): Promise<string[]> => {
  const url = `${ENDPOINTS.GET_COUNTRIES_LIST_WITH_ALLOWED_STATES.replace(
    ENDPOINTS_SEGMENTS.TENANT_ID,
    tenantId,
  )}`;
  const response: Promise<string[]> = Api.get(url);
  return response;
};
